module.exports = __webpack_public_path__ + "static/img/sample_00.955f17c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sample_00.jpg
// module id = m9YA
// module chunks = 1